import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'

export default {
  id: 'clock',
  name: 'clock',
  type: 'standard',
  moduleName: 'editor_module_clock',
  hide: true,
  dataSet: {
    mods: 'clock',
    column: [
      {
        columnId: '',
        type: 'clock',
        detail: {
          options: ['clock', 'border', 'background', 'text', 'padding', 'radius']
        }
      }
    ]
  },
  setting: {
    layout: {
      options: []
    },
    action: null,
    detail: {}
  }
}
